module.exports = __webpack_public_path__ + "static/img/2.8a5acee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/2.png
// module id = 6ym4
// module chunks = 0